import React from "react";
import { useTranslation } from "react-i18next";
import Spacing from "../Spacing";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import AboutStyle4 from "../About/AboutStyle4";
import AboutStyle5 from "../About/AboutStyle5";
import IconBoxStyle6 from "../IconBox/IconBoxStyle6";
import SectionHeadingStyle5 from "../SectionHeading/SectionHeadingStyle5";
import Brands from "../Brands";
import { pageTitle } from "../../helpers/PageTitle";
import { Icon } from "@iconify/react/dist/iconify.js";

const brandList = [
  {
    logoSrc: "/images/unalom/Hoshin_1.png",
    logoAlt: "Hoshin",
    href: "https://hoshincorp.com",
  },
  {
    logoSrc: "/images/unalom/Personnal_Staff_1.png",
    logoAlt: "Personal Staff",
    href: "https://personalstaff.com",
  },
  {
    logoSrc: "/images/unalom/Unique_1.png",
    logoAlt: "Unique",
    href: "https://uniqueenter.com",
  },
  {
    logoSrc: "/images/unalom/novisto_1.png",
    logoAlt: "Novisto",
    href: "https://novisto.com",
  },
];

export default function AboutPage({ darkMode }) {
  const { t } = useTranslation();
  pageTitle(t("header.about"));

  const brandListDark = [...brandList];
  const workProcessSteps = t("workProcess.steps", { returnObjects: true });

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title={t("about.page.title")}
        subTitle={t("about.page.subTitle")}
        variant="text-center"
        shape="shape_1"
      />
      <Spacing lg="75" md="60" />
      <AboutStyle4
        thumbnailSrc="videos/LogoRevealIgnicin_free.mp4"
        miniTitle={t("about.page.info.miniTitle")}
        title={t("about.page.info.title")}
        subTitle={t("about.page.info.description")}
        btnText={t("about.buttonText")}
        btnUrl="/service"
      />
      <Spacing lg="125" md="70" />
      <div className="cs_primary_bg">
        <Spacing lg="125" md="80" />
        <div className="container">
          <Brands data={darkMode ? brandListDark : brandList} />
        </div>
        <Spacing lg="125" md="80" />
      </div>
      <AboutStyle5
        variant="cs_type_1"
        thumbnailSrc="images/unalom/conversionesNombreEvento.jpeg"
        miniTitle={t("results.miniTitle")}
        title={t("results.title")}
        subTitle={t("results.description")}
        progressBarList={[
          { title: t("results.purchase"), percentage: "65" },
          { title: t("results.totalRevenue"), percentage: "42" },
        ]}
        salesTitle={t("results.salesTitle")}
      />
      <a
        href="https://calendly.com/nicolas-rs/new-meeting"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center">
          <Spacing lg="80" md="50" />
          <span className="cs_btn cs_style_1">
            {t("serviceSection.button")}
            <span>
              <i>
                <Icon icon="fa6-solid:arrow-right" />
              </i>
              <i>
                <Icon icon="fa6-solid:arrow-right" />
              </i>
            </span>
          </span>
        </div>
      </a>
      <Spacing lg="150" md="80" />
      <section className="cs_primary_bg">
        <Spacing lg="140" md="70" />
        <div className="container">
          <SectionHeadingStyle5 title={t("workProcess.title")} />
          <Spacing lg="85" md="45" />
          <div className="cs_working_process_wrap cs_center">
            <div className="cs_working_process">
              {workProcessSteps &&
                workProcessSteps.map((step, index) => (
                  <div className="cs_working_process_col" key={index}>
                    <IconBoxStyle6
                      bgSrc={`/images/others/process_${(index % 3) + 1}.png`}
                      iconSrc={`/images/icons/${getIconName(index)}.svg`}
                      title={step.title}
                      subTitle={step.description}
                    />
                  </div>
                ))}
            </div>
          </div>
        </div>
        <Spacing lg="150" md="80" />
      </section>
     
    </>
  );
}

// Función auxiliar para obtener nombres de iconos basados en el índice
function getIconName(index) {
  const iconNames = [
    "search",
    "gear",
    "target-with-arrow",
    "idea",
    "graphic-arrow",
  ];
  return iconNames[index] || "search";
}
